import { css } from '@emotion/core';
import { tokens, applyFont } from '@domain-group/fe-brary';
import { truncateLines } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors,
  typography = tokens.typography;
export var articleCard = /*#__PURE__*/css("flex-grow:1;flex-direction:column;display:flex;width:100%;border-radius:3px;overflow:hidden;min-height:100px;align-items:stretch;&:hover .title{color:", colors.neutral.heavy.hover, ";}");
export var link = /*#__PURE__*/css("color:", colors.neutral.heavy.default, ";text-decoration:none;");
export var content = {
  name: "o9jltu",
  styles: "display:flex;align-items:start;flex-grow:1;gap:16px;"
};
export var leftImageContainer = {
  name: "estb3y",
  styles: "display:block;width:100px;img{width:100%;min-width:100px;height:100%;min-height:100px;object-fit:cover;}"
};
export var middle = {
  name: "15a9kh2",
  styles: "display:flex;flex-direction:column;flex-grow:1;justify-content:space-between;gap:8px;"
};
export var category = /*#__PURE__*/css(applyFont(typography.miniBold), " color:", colors.neutral.medium.default, ";text-transform:uppercase;");
export var heading = /*#__PURE__*/css(applyFont(typography.body), " ", truncateLines(3));